import {
  redux_getAllProjects,
  redux_getProject,
  redux_updateProject,
  redux_createProject,
  redux_projectActionStarts,
  redux_projectActionErrors,
  redux_resetProjectErrors,
} from '../../core/data/redux/modules/project/actions';

import { Dispatch } from 'redux';
import { makeApiRequest } from '../../utils/api-utils';

export const getAllProjects = () => async (dispatch: Dispatch) => {
  dispatch(redux_projectActionStarts());
  try {
    const response = await makeApiRequest(`/projects/get-all`);
    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_projectActionErrors(responseDto.error));
      } else {
        dispatch(redux_getAllProjects(responseDto.data));
      }
  } catch (error) {
    dispatch(redux_projectActionErrors((error as any)?.message || 'Error fetching projects',));
  }
};

export const createProject = (projectData: any, setModalOpen?: (value: boolean) => void) => async (dispatch: Dispatch) => {
  dispatch(redux_projectActionStarts());
  try {
    const response = await makeApiRequest(`/projects/add`, {
      method: 'POST',
      body: JSON.stringify(projectData),
    });

    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_projectActionErrors(responseDto.error));
      } else {
        dispatch(redux_createProject(responseDto.data));
        if (setModalOpen) {
          setModalOpen(false);
        }
      }
  } catch (error) {
    dispatch(redux_projectActionErrors((error as any)?.message || 'Error creating project',));
  }
};

export const updateProject = (id: string, projectData: any, setModalOpen?: (value: boolean) => void) => async (dispatch: Dispatch) => {
  dispatch(redux_projectActionStarts());
  try {
    const response = await makeApiRequest(`/projects/update/${id}`, {
      method: 'PUT',
      body: JSON.stringify(projectData),
    });

    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_projectActionErrors(responseDto.error));
      } else {
        dispatch(redux_updateProject(responseDto.data));
        if (setModalOpen) {
          setModalOpen(false);
        }
      }
  } catch (error) {
    dispatch(redux_projectActionErrors((error as any)?.message || 'Error updating project',));
  }
};

export const deleteProject = (id: string) => async (dispatch: Dispatch) => {
  dispatch(redux_projectActionStarts());
  try {
    const response = await makeApiRequest(`/projects/delete/${id}`, {
      method: 'DELETE',
    });

    const responseDto = response;
    if (responseDto.error) {
        dispatch(redux_projectActionErrors(responseDto.error));
      } 
  } catch (error) {
    dispatch(redux_projectActionErrors((error as any)?.message || 'Error deleting project',));
  }
};
